import React from "react";

export default function Footer({
    company = "ZeroOne IT Solutions",
    companyHref = "",
    year = new Date().getFullYear(),
    className = "",
    style,
    variant = "default",
    noBorder = false,
    noPadding = false,
    showLegalLinks = false,
}) {
    const isLight = variant === "light";
    const baseTextClass = isLight ? "text-slate-300" : "text-gray-500";
    const dividerClass = isLight ? "text-slate-500" : "text-gray-300";
    const subtleTextClass = isLight ? "text-slate-400" : "text-gray-400";
    const borderClass = isLight ? "border-slate-700/60" : "border-gray-200";

    return (
        <div
            className={`w-full flex flex-col sm:flex-row flex-wrap justify-center items-center gap-1 sm:gap-2 text-xs ${baseTextClass} ${
                noPadding ? "" : "py-4"
            } ${noBorder ? "" : `border-t ${borderClass}`} ${className}`}
            style={style}
        >
            <span className={baseTextClass}>
                &copy; {year}{" "}
                {companyHref ? (
                    <a
                        href={companyHref}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="underline-offset-4 transition hover:underline"
                    >
                        {company}
                    </a>
                ) : (
                    company
                )}
            </span>
            <span className={`hidden sm:inline ${dividerClass}`}>|</span>
            <span className={baseTextClass}>All rights reserved</span>
            {showLegalLinks && (
                <>
                    <span className={`hidden sm:inline ${dividerClass}`}>|</span>
                    <span className={subtleTextClass}>Secure POS Platform</span>
                </>
            )}
        </div>
    );
}
